// use strict mode
'use strict';
import $ from "jquery";
import axios from 'axios';
import noUiSlider from 'nouislider';

import * as Chartist from 'chartist';
import * as ChartistTooltip from 'chartist-plugin-tooltips';

import {default as NProgress} from 'nprogress';

import 'parsleyjs';
import SimpleBar from 'simplebar';
import moment from 'moment';
import SmoothScroll from 'smooth-scroll';

import trumbowyg from 'trumbowyg';
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css';
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js';
// Import DataTables and its Bootstrap 5 styling
import 'datatables.net-bs5';

// Import DataTables Buttons and its Bootstrap 5 styling
import 'datatables.net-buttons-bs5';
// Import DataTables core (this should already be in your project)
import 'datatables.net';

import 'laravel-datatables-vite';


// Now import the Buttons extension, if needed
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.colVis.min.js';
import 'datatables.net-buttons/js/buttons.print.min.js';
import 'datatables.net-buttons/js/buttons.html5.min.js';

import 'datatables.net-responsive';
import 'datatables.net-rowreorder';

import Helper from './scripts'
import {textMarshal} from "text-marshal";
import {Notyf} from 'notyf';
import ClipboardJS from "clipboard";

window._ = require('lodash');

try {
    window.$ = window.jQuery = $;
    window.Popper = require('@popperjs/core');
    window.bootstrap = require('bootstrap');
    require('select2');
    // require('bootstrap-daterangepicker');
    window.flatpicker = require('flatpickr');
    // window.CustomPeriodsPlugin = require('./flatpicker-periods');
    // window.DynamicPluginLoader = require('./flatpicker-plugins');
    window.rangePlugin = require('flatpickr/dist/plugins/rangePlugin');

} catch (e) {
    console.log(e);
}
//
// import Alpine from 'alpinejs';
// window.Alpine = Alpine;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });

window.noUiSlider = noUiSlider;

window.Chartist = Chartist;
window.Chartist.plugin = {};
window.Chartist.plugin.tooltip = ChartistTooltip;

window.ClipboardJS = ClipboardJS;
window.Notify = Notyf;


window.SimpleBar = SimpleBar;

window.moment = moment;

window.SmoothScroll = SmoothScroll;

window.trumbowyg = trumbowyg
window.textMarshal = textMarshal
window.Helper = Helper;
window.NProgress = NProgress;

window.flatDatapickerSettings = {
    dateFormat: "m/d/Y",
    allowInput: true,
    locale: {
        firstDayOfWeek: 1
    }
};
window.flatDatapickerTimeSettings = {
    ...window.flatDatapickerSettings,
    enableTime: true,
    dateFormat: "m/d/Y H:i",
    defaultDate: new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    })
}
window.flatDatapickerRangeSettings = {
    ...window.flatDatapickerSettings,
    enableTime: false,
};

window.trumbowygSettings = {
    btns: [
        //['viewHTML'],
        ['undo', 'redo'], // Only supported in Blink browsers
        ['formatting'],
        ['strong', 'em', 'del'],
        ['superscript', 'subscript', 'foreColor', 'backColor'],
        ['link'],
        //['insertImage'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
        ['unorderedList', 'orderedList'],
        ['horizontalRule'],
        ['removeformat'],
        ['fullscreen']
    ],
    autogrow: true,
    svgPath: '/assets/icons/trumbowyg-icons.svg'
}

